import { render, staticRenderFns } from "./setInvite.vue?vue&type=template&id=127ba52e&scoped=true"
import script from "./setInvite.vue?vue&type=script&lang=js"
export * from "./setInvite.vue?vue&type=script&lang=js"
import style0 from "./setInvite.vue?vue&type=style&index=0&id=127ba52e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ba52e",
  null
  
)

export default component.exports